(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.capsuleButtons = document.getElementById('capsule_nav_buttons');
      this.capsuleButtonsTwo = document.getElementById('capsule_nav_buttons_two');
      this.collectionFilters = document.getElementById('main-collection-filters');
      
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header = document.getElementById('shopify-section-header');
      
      if (this.header.classList.contains('menu-open')) {
        return false;
      } else {
        //this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.classList.add('shopify-section-header-sticky');
        if (document.getElementById('capsule_nav_buttons')) {
          this.capsuleButtons.classList.add('header-hidden', 'shopify-section-header-sticky');
          this.capsuleButtons.classList.remove('animate');
        }
        if (document.getElementById('capsule_nav_buttons_two')) {
          this.capsuleButtonsTwo.classList.add('header-hidden', 'shopify-section-header-sticky');
          this.capsuleButtonsTwo.classList.remove('animate');
        }
        if (document.getElementById('main-collection-filters')) {
          this.collectionFilters.classList.add('header-hidden', 'shopify-section-header-sticky');
          this.collectionFilters.classList.remove('animate');
        }
        this.closeMenuDisclosure();
      }
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (document.getElementById('capsule_nav_buttons')) {
        this.capsuleButtons.classList.add('shopify-section-header-sticky', 'animate');
        this.capsuleButtons.classList.remove('header-hidden');
      }
      if (document.getElementById('capsule_nav_buttons_two')) {
        this.capsuleButtonsTwo.classList.add('shopify-section-header-sticky', 'animate');
        this.capsuleButtonsTwo.classList.remove('header-hidden');
      }
      if (document.getElementById('main-collection-filters')) {
        this.collectionFilters.classList.add('shopify-section-header-sticky', 'animate');
        this.collectionFilters.classList.remove('header-hidden');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (document.getElementById('capsule_nav_buttons')) {
        this.capsuleButtons.classList.remove('header-hidden', 'animate', 'shopify-section-header-sticky');
      }
      if (document.getElementById('capsule_nav_buttons_two')) {
        this.capsuleButtonsTwo.classList.remove('header-hidden', 'animate', 'shopify-section-header-sticky');
      }
      if (document.getElementById('main-collection-filters')) {
        this.collectionFilters.classList.remove('header-hidden', 'animate', 'shopify-section-header-sticky');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
